import store from '../store/index'
import router from '../../router'

const DefaultHandlers = {
    success: function() {
        // Requisição bem sucedida. "Renovar" o token na store
        let tokenStore = store.getters.getSystemJwtToken;
        if (tokenStore !== null || tokenStore !== undefined) {
            let novaDataExpiracao = new Date();
            novaDataExpiracao.setMinutes(novaDataExpiracao.getMinutes() + tokenStore.tempoRenovacaoToken);
            tokenStore.expiracao = novaDataExpiracao;
            store.commit("setSystemJwtToken", tokenStore);
        }
    },

    failure: function(error, isSystemUser = false) {
        if (error.isAxiosError) {
            router.push({ name: 'Erro', params: 
            {
                mensagem: error.message,
                statusCode: (typeof error === "array" || typeof error === "string") && error.includes('status code 401') ? '401' : '500',
                method: error.config.method,
                responseUrl: error.config.url,
                authorization: error.config.headers.Authorization,
            } });
        } else {
            if (error.status === 401 /* UNAUTHORIZED */) {
                let tokenStore = store.getters.getSystemJwtToken;

                if (tokenStore == null) { // Usuário ainda não fez login
                    router.push({ name: 'Login', params: { loginExpirado: false, mensagem: "Nenhum usuário logado. Faça o login para continuar." }});
                } else { // Existe um usuário logado. A sessão provavelmente expirou na API
                    store.commit("setSystemJwtToken", null);

                    router.push({ name: 'Login', params: 
                    {
                        loginExpirado: true,
                        mensagem: "O sistema ficou muito tempo ocioso e a sessão expirou. Faça login novamente para continuar." 
                    }});
                }
            } else {
                const retorno = JSON.parse(error.request.response);

                router.push({ name: 'Erro', params: 
                {
                    mensagem: retorno.Mensagem,
                    detalhes: retorno.Detalhes,
                    statusCode: error.status,
                    method: error.config.method,
                    responseUrl: error.config.url,
                    authorization: error.config.headers.Authorization,
                } });
            }
        }
    }
}

export default DefaultHandlers;